import { tw } from '@/utils/tw';

const MorePagesTitle = tw.theme({
  base: `my-6 text-headline`,
});

export default MorePagesTitle;
